import React from 'react';
import { Link } from 'react-router-dom';
import './NotFound.css';
import Astronauta from '../../assets/images/vetores/Astronaut suit-pana.png';
import usePageMeta from '../../hooks/usePageMeta';

const NotFound = () => {
  usePageMeta({ title: 'Página não encontrada' });

  return (
    <div className="not-found-container">
      <div className="not-found-content">
        <h1>404</h1>
        <p>Oops! Parece que você se perdeu no espaço.</p>
        <Link to="/" className="home-link">
          Voltar para o Início
        </Link>
      </div>
      <div className="not-found-animation">
        <img src={Astronauta} alt="Astronauta no Espaço" className="space-image" />
      </div>
    </div>
  );
};

export default NotFound;
